// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LinkButton_wrapper__3hcsW","primary":"LinkButton_primary__2xx2F","danger":"LinkButton_danger__30CNm"};